import moment from 'moment';

interface StartEndDate {
  startDate: Date;
  endDate: Date;
}

export const getStartEndDates = ({
  unit,
  initialStartDate,
  initialEndDate,
}: {
  unit: moment.unitOfTime.StartOf;
  initialStartDate?: Date;
  initialEndDate?: Date;
}): StartEndDate => ({
  startDate: moment(initialStartDate).startOf(unit).toDate(),
  endDate: moment(initialEndDate).endOf(unit).toDate(),
});

interface DurationDateOperation {
  initialDate?: Date;
  operation: 'subtract' | 'add';
  amount: moment.DurationInputArg1;
  unit: moment.DurationInputArg2;
}

const getDateDurationOperation = ({
  initialDate,
  operation,
  amount,
  unit,
}: DurationDateOperation): Date =>
  moment(initialDate)[operation](amount, unit).toDate();

type DurationDateRangeItem = Omit<DurationDateOperation, 'initialDate'>;

export const getRangesDate = ({
  start,
  end,
  initialDate,
}: {
  start?: DurationDateRangeItem;
  end?: DurationDateRangeItem;
  initialDate?: Date;
}): StartEndDate => {
  const currentDate = moment(initialDate).toDate();

  const initialStartDate = start
    ? getDateDurationOperation({
        initialDate: currentDate,
        ...start,
      })
    : currentDate;

  const initialEndDate = end
    ? getDateDurationOperation({
        initialDate: currentDate,
        ...end,
      })
    : currentDate;

  return getStartEndDates({ unit: 'day', initialStartDate, initialEndDate });
};
